import React from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export type SafetyManagementLineageCrumb = {
  label: string;
  href?: string | null;
};

/**
 * Case → Scan → Record lineage. Labels must come from persisted/signed facts,
 * never from a live Case recomputation.
 */
export function SafetyManagementLineageBreadcrumbs({
  crumbs,
  testId,
  ariaLabel,
}: {
  crumbs: SafetyManagementLineageCrumb[];
  testId: string;
  ariaLabel: string;
}) {
  return (
    <Breadcrumbs aria-label={ariaLabel} data-testid={testId} sx={{ '& .MuiBreadcrumbs-ol': { flexWrap: 'wrap' } }}>
      {crumbs.map((crumb, index) => {
        const last = index === crumbs.length - 1;
        if (!last && crumb.href) {
          return (
            <Link key={`${crumb.label}-${index}`} component={RouterLink} to={crumb.href}>
              {crumb.label}
            </Link>
          );
        }
        return (
          <Typography key={`${crumb.label}-${index}`} color={last ? 'text.primary' : 'text.secondary'}>
            {crumb.label}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
}
